/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
// Fix performance drop when devtools is open
// https://github.com/angular/zone.js/issues/875
(window as any).__Zone_disable_RequestAnimationFrame = false;
